import styles from './Pill.module.css';

const Pill = ({ children }) => {
    return <span className={styles.pill}>{children}</span>;
};

export default Pill;
